import React from 'react';
import { styled } from 'linaria/react';

import { theme } from '../Theme';

export const ColumnWrapper = styled('div')`
  position: relative;
  width: ${props => props.width}%;
  padding: 20px;
  flex-grow: 1;
  ${theme.below.lg} {
    width: 100% !important;
    flex: none;
    padding: 20px 0;
  }
`;

export const RowWrapper = styled('section')`
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: flex-start;
  align-items: stretch;
  margin-left: -20px;
  margin-right: -20px;
  margin-bottom: 10px;
  margin-top: 10px;

  width: auto;
  min-width: 100%;

  ${theme.below.lg} {
    flex-wrap: wrap;
    margin: 0;
  }

  &.maxWidth {
    margin: auto;
    width: 100%;
    min-width: 0;
    max-width: ${props => props.maxWidth};
    padding: 0 20px;
  }
`;

export const Column = ({ children, child, width }) => (
  <ColumnWrapper width={width}>{children}</ColumnWrapper>
);

const Row = ({ children, maxWidth, oneThird }) => {
  return (
    <React.Fragment>
      {children.props ? (
        <RowWrapper
          className={maxWidth ? 'maxWidth' : null}
          maxWidth={maxWidth}
        >
          <Column children={children} width={oneThird ? 100 / 3 : 100 / 2} />
        </RowWrapper>
      ) : null}
      {children.length > 0 ? (
        <RowWrapper
          className={maxWidth ? 'maxWidth' : null}
          maxWidth={maxWidth}
        >
          {children.map((child, index) => (
            <Column
              children={child}
              key={index}
              width={100 / children.length}
            />
          ))}
        </RowWrapper>
      ) : null}
    </React.Fragment>
  );
};

export default Row;
